import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Padres que se sienten identificados con el término "madre/padre explosivo".', 'Familias bilingües que gestionan altos niveles de estrés y carga mental.', 'Personas que aman profundamente a sus hijos pero odian su propia irritabilidad.', 'Padres que buscan soluciones prácticas de 5 minutos, no teorías extensas.'];
  const notFor = ['Personas que buscan un sustituto a una terapia clínica para traumas profundos.', 'Quienes no están dispuestos a dedicar 60 segundos a practicar una técnica física.', 'Padres que creen que el castigo físico es la única forma de disciplina.'];
  return <AnimatedSection className="bg-white" data-id="element-265">
      <div className="max-w-6xl mx-auto" data-id="element-266">
        <div className="text-center mb-16" data-id="element-267">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-268">
            ¿Es este kit para ti?
          </h2>
          <p className="text-lg text-charcoal-light" data-id="element-269">
            Seamos honestos sobre quién se beneficiará realmente de este método.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-270">
          {/* For You */}
          <div className="bg-mint-light/30 rounded-3xl p-8 border border-mint-light" data-id="element-271">
            <h3 className="text-2xl font-bold text-charcoal mb-8 flex items-center gap-3" data-id="element-272">
              <span className="bg-mint text-white p-2 rounded-full" data-id="element-273">
                <CheckCircle2 className="w-6 h-6" data-id="element-274" />
              </span>
              Este kit ES para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-275">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-276">
                  <CheckCircle2 className="w-6 h-6 text-mint flex-shrink-0 mt-0.5" data-id="element-277" />
                  <span className="text-charcoal-light text-lg" data-id="element-278">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-red-50/50 rounded-3xl p-8 border border-red-100" data-id="element-279">
            <h3 className="text-2xl font-bold text-charcoal mb-8 flex items-center gap-3" data-id="element-280">
              <span className="bg-red-400 text-white p-2 rounded-full" data-id="element-281">
                <XCircle className="w-6 h-6" data-id="element-282" />
              </span>
              Este kit NO es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-283">
              {notFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-284">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-285" />
                  <span className="text-charcoal-light text-lg" data-id="element-286">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}